import React from "react";
import { Card } from "antd";
import CountUp from "react-countup";

const { Meta } = Card;

const CardMonitor = ({ title, description, icon, color, actions, value, isNumber = false }) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <Card 
      className="modern-card hover:shadow-xl transition-all duration-300 border-0 w-full"
      style={{
        borderRadius: isMobile ? "12px" : "20px",
        background: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        overflow: "hidden",
        marginBottom: isMobile ? "12px" : "16px",
      }}
      actions={actions ? [
        <div className="flex items-center justify-center py-2" key="actions">
          <div className="flex items-center space-x-2 text-gray-600 hover:text-blue-600 transition-colors duration-200">
            {actions}
          </div>
        </div>
      ] : undefined}
      bodyStyle={{ 
        padding: isMobile ? "16px" : "24px",
      }}
    >
      <div className={`flex ${isMobile ? 'flex-col space-y-3' : 'items-start space-x-4'}`}>
        {icon && (
          <div className={`flex ${isMobile ? 'justify-center' : 'justify-start'}`}>
            <div
              className={`${isMobile ? 'w-12 h-12' : 'w-16 h-16'} flex items-center justify-center rounded-2xl text-white ${isMobile ? 'text-xl' : 'text-2xl'} shadow-lg flex-shrink-0`}
              style={{ 
                background: `linear-gradient(135deg, ${color}, ${color}dd)`,
                boxShadow: `0 8px 25px ${color}40`,
              }}
            >
              {icon}
            </div>
          </div>
        )}
        <div className={`flex-1 min-w-0 ${isMobile ? 'text-center' : ''}`}>
          <div className={`${isMobile ? 'text-xs' : 'text-sm'} font-medium text-gray-500 uppercase tracking-wide mb-1`}>
            {title}
          </div>
          {isNumber && typeof value === 'number' ? (
            <div className={`${isMobile ? 'text-2xl' : 'text-3xl'} font-bold text-gray-800 mb-2`}>
              <CountUp 
                end={value} 
                duration={2}
                separator=","
                preserveValue
              />
            </div>
          ) : (
            <div className={`${isMobile ? 'text-xl' : 'text-2xl'} font-bold text-gray-800 mb-2 ${isMobile ? 'truncate' : ''}`}>
              {value || description}
            </div>
          )}
          {description && value && (
            <div className={`${isMobile ? 'text-xs' : 'text-sm'} text-gray-600 line-clamp-2`}>
              {description}
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default CardMonitor;
